<template>
  <div class="product-card" @click.stop="openWarningIfAllowed">
    <div class="image">
      <h4>{{ product.name }}</h4>
      <img
        :src="
          product.images?.length
            ? product.images[0]?.image
            : require('@/assets/images/logo_x.svg')
        "
        alt="Фото товара"
      />
      <span v-if="product.isVerified" class="badge">Проверено</span>
    </div>
    <div class="info">
      <div class="price-and-like">
        <div class="price">{{ Math.trunc(Number(product.price)) }} р</div>
        <button
          @click.stop="clickLike"
          class="like-button"
          :class="{ liked: likedProduct === true }"
        >
          <svg
            width="20"
            height="18"
            viewBox="0 0 16 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.18054 13.5549L7.17983 13.5542C5.11017 11.6365 3.43202 10.0786 2.26545 8.62023C1.10468 7.16915 0.5 5.8759 0.5 4.49591C0.5 2.23655 2.22166 0.5 4.4 0.5C5.6368 0.5 6.83521 1.09095 7.61714 2.02186L8 2.47767L8.38286 2.02186C9.16479 1.09095 10.3632 0.5 11.6 0.5C13.7783 0.5 15.5 2.23655 15.5 4.49591C15.5 5.8759 14.8953 7.16915 13.7346 8.62023C12.568 10.0786 10.8898 11.6365 8.82017 13.5542L8.81946 13.5549L8 14.3171L7.18054 13.5549Z"
              stroke="#313132"
            />
          </svg>
        </button>
      </div>
      <!-- <p class="desc">{{ product.description }}</p> -->
      <p class="desc">
        {{ shortDescription }}
        <span
          v-if="product.description?.length > 50"
          class="more-link"
          @click.stop="openWarningIfAllowed"
        >
          Подробнее
        </span>
      </p>
      <!-- <div class="props">
        <span>Размер: {{ product.size }}</span>
        <span>Цвет: {{ product.color }}</span>
        <span>ГОСТ: {{ product.gost }}</span>
      </div> -->
    </div>
    <div class="seller">
      <div class="seller-name">
        {{ product.company?.name_full || product.entrepreneur?.fio }}
      </div>
      <div class="verified">
        <img src="@/assets/images/icons/verified.svg" />Проверен X-Global
      </div>
      <div class="verified">
        <img src="@/assets/images/icons/verified.svg" />Рейтинг надежности
      </div>
      <div class="rating" v-if="product.rating">★ {{ product.rating }}</div>
      <!-- <button class="btn">Написать</button>
      <button class="btn">Перейти в компанию</button> -->
      <button class="btn-secondary">Перейти к объявлению</button>
    </div>
  </div>
  <BuyASubscriptionWarningModal ref="subscriptionWarningModal" />
</template>

<script>
import { defineComponent, ref, computed } from "vue";
import MarketplaceService from "@/services/marketplace";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Modal } from "bootstrap";
import BuyASubscriptionWarningModal from "@/components/Modals/BuyASubscriptionWarningModal.vue";

export default defineComponent({
  name: "ProductCard",
  components: { BuyASubscriptionWarningModal },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const productAdded = ref(false);
    const likedProduct = ref(props.product?.is_liked);
    const isLoggedIn = computed(() => store.state.auth.status.loggedIn);
    const currentUser = computed(() => store.state.user.user);

    const shortDescription = computed(() => {
      const description = props.product?.description || "";

      if (description.length <= 50) {
        return description;
      }

      return `${description.slice(0, 50)}... `;
    });

    const subscriptionWarningModal = ref(null);

    const clickLike = async () => {
      if (isLoggedIn.value) {
        if (!likedProduct.value) {
          await MarketplaceService.addToFavorite(props.product.id);
          likedProduct.value = true;
        } else {
          await MarketplaceService.removeFromFavorite(props.product.id);
          likedProduct.value = false;
        }
      } else {
        openModal();
      }
    };

    const openModal = () => {
      const loginModal = new Modal(document.getElementById("authModal"));
      loginModal.show();
    };

    const addToCart = async () => {
      if (isLoggedIn.value) {
        await MarketplaceService.addToBasket(props.product.id, 1);
        store.dispatch("user/getCartItems");

        productAdded.value = true;
        setTimeout(() => {
          productAdded.value = false;
        }, 1000);
      } else {
        openModal();
      }
    };

    const hasAccessToItem = () => {
      if (!isLoggedIn.value) return false;

      const membership = currentUser.value?.name_membership;
      return membership === "Premium" || membership === "Business";
    };

    const openWarningIfAllowed = () => {
      if (hasAccessToItem()) {
        goToItem();
      } else {
        subscriptionWarningModal.value?.openModal();
      }
    };

    const goToItem = () => {
      router.push({
        name: "MarketplaceItem",
        params: { id: props.product.id },
      });
    };

    const formatPrice = (price) => {
      return new Intl.NumberFormat("ru-RU", {
        style: "currency",
        currency: "RUB",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(price);
    };

    return {
      goToItem,
      clickLike,
      addToCart,
      formatPrice,
      likedProduct,
      productAdded,
      openWarningIfAllowed,
      subscriptionWarningModal,
      router,
      shortDescription,
    };
  },
});
</script>

<style scoped lang="scss">
.product-card {
  display: flex;
  background: #fff;
  padding: 16px;
  gap: 32px;
  align-items: flex-start;
  color: rgba(62, 62, 62, 1);
  border-bottom: 1px solid rgb(229, 229, 229);
  cursor: pointer;

  @media (max-width: 768px) {
    flex-direction: column;
  }
  .image {
    width: 300px;
    flex-shrink: 0;

    img {
      width: 300px;
      height: 240px;
      object-fit: cover;
      border-radius: 10px;
      display: block;
    }

    h4 {
      height: 58px;
      overflow: hidden;
      margin-bottom: 12px;
    }
  }

  .badge {
    background: #e6f7ec;
    color: #0b8345;
    font-size: 12px;
    padding: 2px 8px;
    border-radius: 6px;
    margin-top: 6px;
    display: inline-block;
  }

  .info {
    flex-grow: 1;
    margin-top: 0;
    position: relative;
    // @media (max-width: 768px) {
    //   width: 100%;
    // }
    .price-and-like {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 10px;
      margin-bottom: 10px;
    }
    .price {
      color: #333;
      font-size: 18px;
      white-space: nowrap;
    }
    .like-button {
      padding: 0;
      border: none;
      cursor: pointer;
      svg {
        width: 20px;
        height: 18px;
        transition: all 0.2s;
        fill: rgba(62, 62, 62, 0.2);
        path {
          stroke: rgba(62, 62, 62, 0.2);
        }
      }
      background-color: inherit;

      &.liked {
        svg {
          fill: #d44233;
          path {
            stroke: #d44233;
          }
        }
      }
    }
    h4 {
      margin: 0 0 4px;
      font-size: 24px;
    }
    .desc {
      font-size: 16px;
      color: #666;

      .more-link {
        color: rgba(0, 199, 130, 1);
        text-decoration: underline;
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }
    }
    .props span {
      display: block;
      font-size: 12px;
      color: #888;
    }
  }

  .seller {
    text-align: left;
    border-left: 1px solid rgba(229, 229, 229, 1);
    height: 100%;
    width: 30%;
    padding: 0 24px;

    @media (max-width: 768px) {
      width: 100%;
      border-left: none;
      padding: 0;
    }
    &-name {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 20px;
    }
    .verified {
      margin-bottom: 16px;
      img {
        margin-right: 12px;
      }
    }
    .btn,
    .btn-secondary {
      display: block;
      margin-top: 8px;
      padding: 6px 12px;
      border-radius: 10px;
      width: 100%;
      font-size: 18px;
      margin-top: 16px;
    }
    .btn {
      background: #fff;
      color: rgba(62, 62, 62, 1);
      border: 1px solid rgba(62, 62, 62, 1);
    }
    .btn-secondary {
      background: rgba(0, 199, 130, 0.2);
      color: rgba(62, 62, 62, 1);
      border: none;
    }
  }
}
</style>
